import Login from "@/components/popup/Login";
import { useAlert, usePopup } from "core/context/useWindow";
import { useCommonState } from "core/context/useContext";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "@/core/store";

const useStateCheck = () => {
  const navigate = useNavigate();
  const { openAlert } = useAlert();
  const { openPopup } = usePopup();
  const { isLogin, siteOpenType } = useCommonState();
  const infoData = useSelector(state => state.Data)

  const showPopup = () => {
    openPopup({
      grandLogin: true,
      content: Login,
      title: t("sectionTitle.login"),
    });
  };

  const showAlert = () => {
    openAlert({
      title: t("alert.join_wait"),
      message: t("alert.join_wait_message"),
    });
  };

  const stateCheck = (url) => {
    // SITE_TYPE 1: 오픈형에서 로그인 없이 접근 가능한 경로
    const isSiteType1 = siteOpenType === '1';
    const openPaths = ['/game_list', '/game_zone', '/FX/', '/mini/', '/event', '/notice', '/eveNot',
      '/recent_games', '/new_games', '/popular_games', '/recommended_games', '/favorite_games', '/lobby_list'];
    const isOpenPath = openPaths.some(path => url.startsWith(path));
    
    if (!isLogin && !(isSiteType1 && isOpenPath)) {
      showPopup();
    } else if (url === "/customer") {
      navigate(url)
    } else if (infoData.state === "W" && !isOpenPath) {
      showAlert();
    } else {
      if (url.startsWith("http://") || url.startsWith("https://")) {
        window.open(url, "_blank");
      } else {
        navigate(url)
      }
    }
  };

  return stateCheck;
};

const LoginCheck = () => {
  return !!store.getState()?.User?.id;
}

export { useStateCheck, LoginCheck };
